import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const TopContainer = styled.div`
  display: flex;
  margin-bottom: 1.25rem;
  justify-content: space-between;
  align-items: center;

  div {
    display: flex;
    gap: 0.3125rem;
  }
`;

export const Table = styled.table`
  background-color: ${Theme.colors.WHITE};
  text-align: center;
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;

  th,
  td {
    height: 2.5rem;
    border: 0.0625rem solid ${Theme.colors.BLACK};
    padding: 0;
    font-size: 0.8125rem;
    white-space: nowrap;
    overflow: hidden;
  }
`;

export const TableHeader = styled.th`
  background-color: ${Theme.colors.G_5};
  text-align: center;
  font-weight: 500;
`;

export const TableFooter = styled.td`
  text-align: left;
  padding: 0.625rem !important;
`;

export const InfoContainer = styled.tbody`
  tr td:first-of-type {
    background-color: ${Theme.colors.G_5};
    font-weight: 500;
  }
  tr.total-row td {
    background-color: ${Theme.colors.G_5};
    font-weight: 700;
  }
`;

export const MonthCol = styled.col`
  width: 3.5rem;
`;

export const DataCol = styled.col`
  /* Shares remaining space equally */
`;

export const ResultSection = styled.div`
  margin-top: 1.25rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
`;

export const ResultCard = styled.div`
  background-color: ${Theme.colors.WHITE};
  border: 0.0625rem solid ${Theme.colors.BLACK};
  padding: 0.75rem;
`;

export const ResultLabel = styled.div`
  font-size: 0.75rem;
  color: ${Theme.colors.BLACK};
  margin-bottom: 0.25rem;
  font-weight: 500;
`;

export const ResultValue = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: ${Theme.colors.B_2};
`;

export const ResultSubText = styled.div`
  font-size: 0.6875rem;
  color: ${Theme.colors.G_1};
  margin-top: 0.25rem;
`;

export const CellInput = styled.input`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: none;
  border-radius: 0;
  padding: 0 0.25rem;
  text-align: right;
  font-size: 0.8125rem;
  outline: none;
  background-color: ${Theme.colors.YELLOW};

  &:disabled {
    background-color: transparent;
    color: ${Theme.colors.BLACK};
    cursor: default;
    text-align: center;
  }
`;

export const MetaInput = styled.input`
  width: 12rem;
  height: 2.5rem;
  border: 0.0625rem solid ${Theme.colors.BLACK};
  padding: 0 0.625rem;
  font-size: 0.8125rem;
  outline: none;
  background-color: ${Theme.colors.YELLOW};

  &:disabled {
    background-color: transparent;
    color: ${Theme.colors.BLACK};
  }
`;

export const StyledTextarea = styled.textarea`
  display: block;
  width: 100%;
  min-height: 4rem;
  background-color: ${Theme.colors.YELLOW};
  border: none;
  padding: 0.3125rem;
  color: ${Theme.colors.BLACK};
  font-size: 0.8125rem;
  font-weight: 400;
  resize: none;
  font-family: inherit;

  :disabled {
    background-color: transparent;
  }

  ::placeholder {
    color: ${Theme.colors.G_2};
  }

  :focus {
    outline: none;
  }
`;
